<template>
  <div>

    <!--title start-->
    <div id="printtitle">
      <!-- menu title -->
      <div class="grab">
        <div class="tit_nav">
          <h4>{{$t(title)}}</h4>
        </div>
      </div>
    </div>


    <!--content start-->
    <div id="board02_write_wrap" class="board-write">
      <div class="grab">
        <form class="form-horizontal">
          <label for="title" class="control-label">{{ $t("title") }}</label>
          <textarea class="form-control" id="title" rows="3" v-model="t_text" v-bind:placeholder="$t('title_placeholder')"></textarea>
        </form>
        <form>
          <label for="writeDate" class="control-label" style="display: block">작성시간</label>
          <!--날짜
          <input id="writeDate" type="datetime-local" v-model="writeDate"/>-->
          <input id="writeDate" type="datetime-local" v-model="writeDate"/>

        </form>
        <!--편집기-->
        <form class="form-horizontal" style="margin-top: 18px">
          <label for="content" class="control-label">{{ $t("content") }}</label>
          <wysiwyg v-model="contents"></wysiwyg>
        </form>

        <button v-on:click="done()">{{ $t("save") }}</button>
        <button v-on:click="cancel()">{{ $t("cancel") }}</button>
      </div>
    </div>

  </div>
</template>
<script>
  import api from '../api/api'

  export default {
    name: 'NoticeWrite',
    data () {
      return {
        t_text:'',
        contents:'',
        dateNow: new Date(),
        writeDate: '2019-01-01T13:00'
      }
    },
    props: {
      type : { default:0}, //0;센터소식 , 1: 학술 및 홍보활동
      contentsNo: {default:0}
    },
    components : {
    },
    langText: 'ENGLISH',
    computed: {
      title : function () {
        if(this.type==0) {
          if (this.contentsNo == 0) return "news_add";
          else return "news_edit";
        }
        else if(this.type==1) {
          if (this.contentsNo == 0) return "active_add";
          else return "active_edit";
        }
      },
    },
    created: function ()
    {
      console.log('## created contents no : ' + this.contentsNo)
      if(this.contentsNo > 0) {
        console.log('## created contents no : ' + this.contentsNo)
        api.reqContents(this.contentsNo)
          .then((response) => {
            if (response.data.status === 'success') {
              this.t_text = response.data.title;
              this.contents = response.data.contents;
              this.writeDate = response.data.date;
            }
            else {
              console.log('## 3 ' + JSON.stringify(response.data));
              alert('에러 : ' + response.data.message)
            }
          })
      }
      else
      {
        console.log('## created contents no : ' + this.contentsNo)
        var today = new Date()
        var timezoneOffset = new Date().getTimezoneOffset() * 60000;
        var timezoneDate = new Date(Date.now() - timezoneOffset);


        //출처: https://bloodguy.tistory.com/entry/JavaScript-DatetoISOString-timezone-offset-반영 [Bloodguy]
        this.writeDate = timezoneDate.toISOString().substring(0,16)
        console.log('## today : ' + this.writeDate)

      }
    },
    methods: {
      done : function() {
        console.log('##' + this.t_text + ' ' + this.writeDate)
        var category = (this.type==0)? 5 : 6
        api.write( this.contentsNo , category, this.t_text , this.contents , this.writeDate)
          .then((response) => {
            console.log('## 3 ' + JSON.stringify(response.data));
            console.log('## 32 ' + 'done')
            //
            if (response.data.status === 'success') {
              this.$router.back()
            } else {
              alert('글 작성에 실패 하였습니다.')
            }
          })
        //this.$router.back()
      },
      cancel : function() {
        this.$router.back()
      }
    }
  }
</script>
<style scoped>
  .richedit {
    height: 500px;
  }

</style>



// WEBPACK FOOTER //
// src/components/NoticeWrite.vue